import {useQuery} from '@tanstack/react-query';
import {GetBannersRequest} from 'domain/usecases';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getBanners} from '../../services/getBanners';

export const useGetBannersQuery = (params: GetBannersRequest) =>
	useQuery({
		queryKey: [QUERY_KEYS.BANNERS, params],
		queryFn: ({signal}) => getBanners({...params, signal}),
		enabled: !!params.canal && !!params.operadora,
	});
